import { get, set } from "lodash";
import angular from "angular";
import { StateParams } from "@uirouter/angularjs";
import { IOnInit, ICompileService } from "angular";
import { RecordDataSource } from "../../../records/grids";
import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../records/server/query";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../app/records/server/serverUtility";

import "angular-formly";
import { $confirm } from "../../../../@custom_types/confirm";
import * as XLSX from "xlsx";

const gridId = Symbol("main.jobs");

export class WebJobsController implements IOnInit {
  static $inject = [
    "$stateParams",
    "slotTrakMachinesServer",
    serverUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    "$compile",
    "$confirm",
    "$q",
  ];

  readonly gridDataSource: RecordDataSource;
  readonly gridSettings: IGridSettings;
  readonly columns: ColDef[];
  readonly defaultQuery: IQuery = {};

  public onAddNew: any;
  public isUploading: boolean = false;
  public uploadError: string = "";

  constructor(
    public readonly $stateParams: StateParams,
    public readonly slotTrakMachinesServer: any,
    public readonly serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    $compile: ICompileService,
    private readonly $confirm: $confirm,
    private readonly $q: ng.IQService
  ) {
    this.gridDataSource = new RecordDataSource(serverUtility, "/api/webjobs");
    this.gridSettings = gridSettingsService.getGridSettings(gridId);

    this.columns = [
      columnDefinitionService.getLinkColDef({
        colId: "info",
        headerName: "Info",
        iconClass: "fa fa-info-circle text-primary",
        stateExpression: "main.webjobs.info({ id: data.Id})",
      }),
      columnDefinitionService.getNumberColDef({
        field: "Id",
        header: "Id",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "MessageId",
        header: "MessageIds",
      }),

      columnDefinitionService.getStringColDef({
        field: "FileName",
        header: "File Name",
        hide: true,
        requiresPermission: "contractViewSensitive",
        cellRenderer: (params) => {
          const FileName = get(params.data, "FileName");
          const fileUrl = get(params.data, "Url");
          if (!fileUrl) {
            return "";
          }

          return `<a href="${fileUrl}" target="_blank">${"Download File"}</a>`;
        },
      }),
      columnDefinitionService.getStringColDef({
        field: "CreatedByDisplayName",
        header: "Created By",
      }),
      columnDefinitionService.getStringColDef({
        field: "Status",
        header: "Status",
      }),
      columnDefinitionService.getStringColDef({
        field: "CreatedDate",
        header: "Created Date",
      }),
      columnDefinitionService.getDateTimeColDef({
        field: "ModifiedDate",
        header: "Completed Date",
        cellRenderer: (params) => {
          const status = get(params.data, "Status");
          const modifiedDate = get(params.data, "ModifiedDate");

          if (status && status.toLowerCase() === "completed" && modifiedDate) {
            return modifiedDate;
          }

          return "";
        },
      }),
      columnDefinitionService.getStringColDef({
        field: "Progress",
        header: "Progress",
        cellRenderer: (params) => {
          const status = get(params.data, "Status");
          const modifiedDate = get(params.data, "ModifiedDate");
          const createdDate = get(params.data, "CreatedDate");
          const PercentageCompleted = get(params.data, "PercentageCompleted");
          
          // Calculate progress based on time elapsed
          let progress = 0;
          if (status?.toLowerCase() === "completed") {
            progress = 100;
          } else if (status?.toLowerCase() === "pending") {
            progress = 0;
          } else if (status?.toLowerCase() === "processing") {
            progress = PercentageCompleted;
          }

          return `
            <div style="display: flex; align-items: center; width: 100%; height: 100%; padding: 4px 0;">
              <div style="
                width: 100%;
                height: 24px;
                background-color: #e9ecef;
                border-radius: 6px;
                overflow: hidden;
                position: relative;
                box-shadow: inset 0 1px 3px rgba(0,0,0,0.1);
              ">
                <div style="
                  width: ${progress}%;
                  height: 100%;
                  background: linear-gradient(90deg, #32B8C6 0%, #1A6873 100%);
                  transition: width 0.5s ease-in-out;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: relative;
                  animation: ${progress < 100 ? "shimmer 2s infinite" : "none"};
                ">
                  <span style="
                    color: white;
                    font-size: 11px;
                    font-weight: 600;
                    text-shadow: 0 1px 2px rgba(0,0,0,0.2);
                    letter-spacing: 0.5px;
                  ">${Math.round(progress)}%</span>
                </div>
              </div>
              <i class="fa fa-refresh text-primary reload-icon" style="cursor: pointer; margin-left: 10px;" title="Reload"></i>
            </div>
            
            <style>
              @keyframes shimmer {
                0% {
                  background: linear-gradient(90deg, #32B8C6 0%, #1A6873 100%);
                  box-shadow: 0 0 10px rgba(50, 184, 198, 0.5);
                }
                50% {
                  background: linear-gradient(90deg, #3cc8d6 0%, #2a7883 100%);
                  box-shadow: 0 0 15px rgba(50, 184, 198, 0.7);
                }
                100% {
                  background: linear-gradient(90deg, #32B8C6 0%, #1A6873 100%);
                  box-shadow: 0 0 10px rgba(50, 184, 198, 0.5);
                }
              }
            </style>
          `;
        },
      }),
    ];
  }

  $onInit(): void {}

  async add() {
    if (this.onAddNew && typeof this.onAddNew[0] === "function") {
      await this.onAddNew[0]();
    } else {
      console.error("Add handler not available");
    }
  }
  triggerFileUpload(): void {
    const fileInput = document.getElementById(
      "excelFileInput"
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  
  async onFileSelected(event: any): Promise<void> {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }
  
    const validTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
    ];
  
    if (!validTypes.includes(file.type) && !file.name.match(/\.(xlsx|xls|csv)$/i)) {
      this.uploadError = "Please upload a valid Excel/CSV file (.xlsx, .xls, or .csv)";
      event.target.value = "";
      return;
    }
  
    this.isUploading = true;
    this.uploadError = "";
  
    try {
      const fileContent: string = await new Promise((resolve, reject) => {
        const fr = new FileReader();
        fr.onload = (e: any) => resolve(e.target.result as string);
        fr.onerror = () => reject(new Error("Failed to read the file"));
        fr.onabort = () => reject(new Error("File read was aborted"));
        fr.readAsText(file);
      });
  
      if (!fileContent || !fileContent.trim()) {
        this.uploadError = "Uploaded file is empty.";
        return;
      }
  
      const lines = fileContent.split(/\r\n|\n/).filter((ln) => ln.trim() !== "");
      if (lines.length === 0) {
        this.uploadError = "No rows found in the uploaded CSV.";
        return;
      }
  
      // Ask user to confirm before sending
      const confirmed = await this.$confirm({
        text: `Found ${lines.length} non-empty line(s) in "${file.name}". Do you want to upload this file to the server?`,
      });
  
      

  
      const fileReader = new FileReader();

    fileReader.onload = async (e: any) => {
      this.serverUtility.sendApiRequest({
        url: "/api/webjobs/serialCsv",
        method: "POST",
        data: e.target.result,
        headers: {
          "Content-Type": "text/csv",
        },
      });
    };

    fileReader.readAsText(file);
  
    } catch (err: any) {
      console.error("Error uploading CSV:", err);
      this.uploadError = "Error uploading file: " + (err?.message || "Unknown error");
    } finally {
      this.isUploading = false;
      event.target.value = "";
    }
  }
  

  private readExcelFile(file: File): ng.IPromise<string[]> {
    return this.$q((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });

          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          const jsonData = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
          }) as any[][];

          const machineIds: string[] = [];
          let machineIdColumnIndex = 0;

          if (jsonData.length > 0 && jsonData[0]) {
            const headers = jsonData[0].map((h) =>
              String(h).toLowerCase().trim()
            );
            const machineIdIndex = headers.findIndex(
              (h) => h === "machineid" || h === "machine id" || h === "id"
            );
            if (machineIdIndex >= 0) {
              machineIdColumnIndex = machineIdIndex;
              jsonData.shift();
            }
          }

          for (const row of jsonData) {
            if (row && row[machineIdColumnIndex]) {
              const id = String(row[machineIdColumnIndex]).trim();
              if (id && id !== "") {
                machineIds.push(id);
              }
            }
          }

          resolve(machineIds);
        } catch (error) {
          reject(error);
        }
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsArrayBuffer(file);
    });
  }

  private sendMachineIdsToApi(machineIds: string[]): void {
    if (!machineIds || machineIds.length === 0) {
      alert("No MachineIds to process.");
      return;
    }

    const payload = {
      MessageId: "",
      Status: "Pending",
      JobType: "machine",
      PayloadJson: JSON.stringify(machineIds.map((id) => ({ MachineId: id }))),
    };

    const injector = (angular as any).element(document.body).injector();
    const $http = injector.get("$http");

    $http
      .post("/api/webjobs", payload, { responseType: "json" })
      .then((response: any) => {
        if (response.status === 200) {
          this.gridDataSource.query = { ...this.gridDataSource.query };
          alert(`Successfully processed ${machineIds.length} MachineId(s)`);
        } else {
          alert("Processing completed with unexpected response.");
        }
      })
      .catch((error: any) => {
        console.error("API Error:", error);
        alert("Failed to send MachineIds to the server.");
      });
  }
}
